import Api from "..";

const getDesignacoes = async (useFilter = false) => {
    try {
        const idUsuario = (typeof window !== 'undefined') ? localStorage.getItem('idUsuario') : null;
    const url = (useFilter && idUsuario) ? `designacao/listarDesignacoes?idUsuario=${idUsuario}` : 'designacao/listarDesignacoes';
        const response = await Api.get(url);
        return response.data;
    } catch (error) {
        throw new Error(`Erro ao buscar designações: ${error.message}`);
    }
}           

const getDesignacaoById = async (id) => {
    try {
        const response = await Api.get(`/designacao/buscarDesignacaoPorId?id=${id}`);
        return response.data;
    } catch (error) {
        throw new Error(`Erro ao buscar designação com ID ${id}: ${error.message}`);
    }
}

const createDesignacao = async (designacaoData) => {            
    try {
        const response = await Api.post("/designacao/criarDesignacao", designacaoData);
        return response.data;
    } catch (error) {
        // Preserva o objeto de erro original do Axios para permitir
        // acesso a error.response.data.detalhes no chamador.
        throw error;
    }
}

const updateDesignacao = async (id, designacaoData) => {
    try {
        const response = await Api.patch(`/designacao/atualizarDesignacao?id=${id}`, designacaoData);
        return response.data;
    } catch (error) {
        // Preserva o objeto de erro original do Axios para permitir
        // acesso a error.response.data.detalhes no chamador.
        throw error;
    }
}

const deleteDesignacao = async (id) => {
    try {
        const response = await Api.delete(`/designacao/deletarDesignacao?id=${id}`);
        return response.data;
    } catch (error) {
        throw new Error(`Erro ao deletar designação com ID ${id}: ${error.message}`);
    }
}

const cancelarDesignacaoCoordenador = async (id) => {
    try {
        const response = await Api.patch(`/designacao/cancelarDesignacaoCoordenador?id=${id}`);
        return response.data;
    } catch (error) {
        throw new Error(`Erro ao cancelar designação com ID ${id}: ${error.message}`);
    }
}

const getDesignacoesPorPublicador = async (publicadorId) => {
    try {
        const response = await Api.get(`/designacao/buscarDesignacoesPorPublicador?publicadorId=${publicadorId}`);
        return response.data;
    } catch (error) {
        throw new Error(`Erro ao buscar designações do publicador: ${error.message}`);
    }
}

const verificarConflito = async (publicadores, data, horario, idDesignacao = null) => {
    try {
        const payload = {
            publicadores,
            data,
            horario
        };
        if (idDesignacao) {
            payload.idDesignacao = idDesignacao;
        }
        const response = await Api.post('/designacao/verificarConflito', payload);
        return response.data;
    } catch (error) {
        throw new Error(`Erro ao verificar conflito: ${error.message}`);
    }
}

export default {
    getDesignacoes,
    getDesignacaoById,
    createDesignacao,
    updateDesignacao,
    deleteDesignacao,
    getDesignacoesPorPublicador,
    cancelarDesignacaoCoordenador,
    verificarConflito
};